module.exports = __webpack_public_path__ + "media/images/flags/32/Qatar-1f7ba71c23349ca5cae504328998fc1e.png";